<template>
    <div class="about">
        <div v-for="history in histories" class="" :key="history.id">
            <div class="merchant font-weight-bold">
                {{ history.name }}
            </div>
            <div class="address">
                {{ history.address }}
            </div>
            <router-link class="btn btn-primary btn-sm float-right" :to="{ name: 'merchant.history', params: {branch_ref_no: history.reference_no} }">{{ lang('More Info') }}</router-link>
            <div class="ref">
                {{ history.reference_no }}
            </div>
            <hr>
        </div>

        <div id="image-viewer">
            <span class="close" @click="closeBrochure()">&times;</span>
        </div>
        <div v-if="state.loading_next" class="text-center">
            Loading..
        </div>
        <loader v-if="state.loading_auth || state.loading_history"></loader>
    </div>
</template>

<script>

export default {
    data() {
        return {
            histories: [],
            next_page: '',
        }
    },

    methods: {
        getHistory() {
            this.$set(this.state, 'loading_history', true)
            axios.get(this.GLOBAL.API_BASE_URL +"branch-visit/branch-history")
                .then(response => {
                    this.histories = response.data.data
                    this.next_page = response.data.links.next
                    this.next_page_no = response.data.meta.current_page + 1

                    this.getNextHistoryPage()
                })
                .catch(error=>defaultErrorManagement(error.response)) //to catch the errors if any
                .finally(() => this.$set(this.state, 'loading_history', false))
        },

        getNextHistoryPage() {
            let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= document.documentElement.offsetHeight

            if(this.next_page && bottomOfWindow) {
                this.$set(this.state, 'loading_next', true)
                axios.get(this.GLOBAL.API_BASE_URL +"branch-visit/branch-history?page="+ this.next_page_no)
                    .then(response => {
                        this.histories.push.apply(this.histories, response.data.data)
                        this.next_page = response.data.next_page_url
                        this.getNextHistoryPage()
                    })
                    .catch(error=>defaultErrorManagement(error.response))
                    .finally(() => this.$set(this.state, 'loading_next', false))

                this.next_page = ''
            }
        },
    },

    created() {
        this.getHistory()

        window.scrollTo(0, 0);

        window.onscroll = () => {
            this.getNextHistoryPage()
        }
    },

    beforeRouteLeave(to, from, next) {
        if(to.name == 'auth') {
            this.closeApp()
        } else {
            next()
        }
    }
}

</script>

<style scoped>

/* The Modal (background) */
#image-viewer {
    display: none;
    position: fixed;
    z-index: 10;
    padding-top: 100px;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0,0.9);
}
.modal-content {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
}
.modal-content { 
    animation-name: zoom;
    animation-duration: 0.6s;
}
@keyframes zoom {
    from {transform:scale(0)} 
    to {transform:scale(1)}
}
#image-viewer .close {
    position: absolute;
    top: 15px;
    right: 35px;
    color: #f1f1f1;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
}
#image-viewer .close:hover,
#image-viewer .close:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
}

@media only screen and (max-width: 700px){
    .modal-content {
        width: 100%;
    }
}
</style>